import Immutable from 'immutable';
import React, { PureComponent } from 'react';
import { graphql, compose } from 'react-apollo';
import Select from 'react-select';
import gql from 'graphql-tag';
import moment from 'moment';
import sortBy from 'lodash/sortBy';
import Tooltip from 'rc-tooltip';
import styled from 'styled-components';

import TasksByWeek from '../../../../fragments/myTasks';
import CriticalPathTasks from '../../../../fragments/criticalPaths';
import Avatar from '../../../../components/Avatar';
import Loading from '../../../../components/Loading';
import {
  List,
  AutoSizer,
  CellMeasurer,
  CellMeasurerCache,
} from 'react-virtualized';

const ReactSelectDropDown = styled(Select)`
  &.Select {
    height: 32px;
  }

  &.Select.is-focused:not(.is-open) > .Select-control {
    border: 1px solid rgba(0, 0, 0, 0.125);
    box-shadow: none;
    -webkit-box-shadow: none;
  }

  .Select-control {
    width: auto;
    height: 32px;
  }

  .Select-option {
    font: 14px Arial;
  }

  &.Select-menu-outer {
    margin-top: 0px;
  }

  &.Select--single {
    .Select-value {
      line-height: 30px;
    }
  }
  .Select-input {
    height: 30px;
  }
  &.Select-arrow-zone {
    height: 30px;
  }
`;

class UserSelectDropdown extends PureComponent {
  state = {
    selectedValue: null,
  };

  constructor(props) {
    super(props);

    this.state = {
      selectedValue:
        (props.selectedUser && props.selectedUser.get('id')) || '-1',
    };
  }

  _onChange = ({ value }) => {
    const { updateSelectedUser, setCurrentElement } = this.props;

    this.setState({ selectedValue: value });
    setCurrentElement(null);

    updateSelectedUser(value);
  };

  render() {
    const { projectUsers } = this.props;

    const options = sortBy(projectUsers, u => u.get('first_name')).map(u => ({
      label: `${u.get('first_name')} ${u.get('last_name')}`,
      value: u.get('id'),
    }));

    const usersArray = [{ label: 'All Tasks', value: '-1' }].concat(options);

    return (
      <ReactSelectDropDown
        autosize={false}
        style={{ font: '14px Arial' }}
        options={usersArray}
        onChange={this._onChange}
        clearable={false}
        placeholder="Change project..."
        value={this.state.selectedValue}
      />
    );
  }
}

class TabItem extends PureComponent {
  handleClick = event => {
    event.preventDefault();
    const { index, onClick } = this.props;
    onClick(index);
  };

  render() {
    const { index, currentIndex, children } = this.props;
    return (
      <li className="nav-item">
        <a
          className={`nav-link ${currentIndex === index ? 'active' : ''}`}
          onClick={this.handleClick}
          style={{ cursor: 'pointer', font: '14px Arial' }}
        >
          {children}
        </a>
      </li>
    );
  }
}

class Tabs extends PureComponent {
  render() {
    const {
      currentIndex,
      onChange,
      projectUsers,
      selectedUser,
      updateSelectedUser,
      setCurrentElement,
    } = this.props;
    console.log('tab props', this.props);
    return (
      <ul
        className="nav nav-pills flex-column flex-sm-row"
        style={{ marginBottom: 10 }}
      >
        <TabItem index={'now'} currentIndex={currentIndex} onClick={onChange}>
          Now
        </TabItem>
        <TabItem index={0} currentIndex={currentIndex} onClick={onChange}>
          One Week
        </TabItem>
        <TabItem index={1} currentIndex={currentIndex} onClick={onChange}>
          Two Weeks
        </TabItem>
        <TabItem index={2} currentIndex={currentIndex} onClick={onChange}>
          Six Weeks
        </TabItem>
        <TabItem
          index={'issues'}
          currentIndex={currentIndex}
          onClick={onChange}
        >
          Task Alerts
        </TabItem>
        <li className="nav-item dropdown ml-auto">
          <UserSelectDropdown
            setCurrentElement={setCurrentElement}
            projectUsers={projectUsers}
            selectedUser={selectedUser}
            updateSelectedUser={updateSelectedUser}
          />
        </li>
      </ul>
    );
  }
}

const dueDate = dueDays => {
  const calendarDueDate = moment().add(dueDays, 'd');
  const diff = moment().diff(calendarDueDate, 'days');

  if (diff === 0) return 'today';
  return calendarDueDate.fromNow();
};

const computeLateDays = lateDays => {
  const adjustment = lateDays === 1 ? 'day' : 'days';

  return `${lateDays} ${adjustment} late`;
};

// const Task = ({ task, isCritical, setCurrentElement }) => {
class Task extends PureComponent {
  _callback = () => {
    const { task, setCurrentElement } = this.props;

    setCurrentElement(task);
  };

  render() {
    const { task, isCritical, style } = this.props;
    const repeatedAvatars = [];

    const waitingRoom = task.successorTasks.reduce((prev, cur) => {
      const currentUser = cur && cur.responsibleUser;

      if (currentUser) {
        const avatar = {
          avatar: currentUser.avatar,
          id: currentUser.id,
          user: currentUser,
        };

        if (prev[currentUser.id]) {
          repeatedAvatars.push(avatar);
        } else {
          prev[currentUser.id] = avatar;
        }
      }

      return prev;
    }, {});

    const waitingRoomUserIds = Object.keys(waitingRoom);
    const repeatedAvatarsToAdd = repeatedAvatars.slice(
      0,
      waitingRoomUserIds.length < 5 ? 5 - waitingRoomUserIds.length : 0,
    );
    const totalLeftover = repeatedAvatars.length - repeatedAvatarsToAdd.length;

    const totalWaitingRoom = waitingRoomUserIds
      .map(u => waitingRoom[u])
      .concat(repeatedAvatarsToAdd);
    const dueInDate = dueDate(task.calendarDueDays);
    const lateDays = computeLateDays(task.lateDays);

    const circle =
      task.mappedType === 'Task' ? (
        <i
          className="fa fa-circle"
          style={{ marginRight: 5, color: task.color.color }}
        />
      ) : (
        <i
          className="fa fa-circle-o"
          style={{ marginRight: 5, color: task.color.color }}
        />
      );

    return (
      <div
        onClick={this._callback}
        className="list-group-item list-group-item-action flex-column align-items-start"
        style={{ ...style, cursor: 'pointer' }}
      >
        <div className="d-flex w-100 justify-content-between">
          <div style={{ width: '80%' }}>
            <h5 className="mb-1">{task.name}</h5>
            <small
              style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
              }}
            >
              <Tooltip placement="bottom" overlay={task.color.help}>
                {circle}
              </Tooltip>
              {task.props.Status && task.props.Status.status}
            </small>
            <small
              style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
              }}
            >
              <div
                className="mb-1 mt-2"
                style={{ display: 'flex', flexDirection: 'row' }}
              >
                {totalWaitingRoom.map((st, k) => (
                  <Avatar
                    className="mr-1"
                    key={k}
                    avatar={Immutable.fromJS(st.avatar)}
                    user={Immutable.fromJS(st.user)}
                    width="37"
                    height="37"
                    rounded
                    enableToolTip
                  />
                ))}
                <div
                  style={{
                    justifyContent: 'center',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  {totalLeftover ? `and ${totalLeftover} more.` : null}
                </div>
              </div>
            </small>
          </div>
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            {dueInDate && (
              <small
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center',
                  justifyContent: 'flex-end',
                  wrap: 'no-wrap',
                }}
              >
                {!task.lateDays && `Due ${dueInDate}`}
                {task.lateDays && (
                  <Tooltip placement="bottom" overlay={'Task Is Running Late'}>
                    <div style={{ color: 'crimson', marginLeft: 5 }}>
                      {lateDays}
                    </div>
                  </Tooltip>
                )}
              </small>
            )}
            {dueInDate && (
              <small
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center',
                  justifyContent: 'flex-end',
                }}
              >
                {task.objectTags &&
                  task.objectTags.tag && (
                    <small
                      style={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        justifyContent: 'flex-end',
                      }}
                    >
                      {task.objectTags.tag.tag}
                    </small>
                  )}
              </small>
            )}
            {isCritical && (
              <div
                style={{
                  display: 'flex',
                  flex: 1,
                  justifyContent: 'flex-end',
                  alignItems: 'flex-end',
                }}
              >
                <Tooltip placement="bottom" overlay={'Task On Critical Path'}>
                  <i
                    className="icomoon icon-cp"
                    aria-hidden="true"
                    style={{ marginLeft: 5, color: 'crimson', fontSize: 20 }}
                  />
                </Tooltip>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

const isCriticalTask = (criticalPaths, taskId) => {
  for (let i = 0; i < criticalPaths.length; i++) {
    const path = criticalPaths[i];
    if (path.indexOf(taskId) > -1) return true;
  }
  return false;
};

const EmptyTab = ({ info }) => (
  <div
    style={{
      display: 'flex',
      flex: 1,
      justifyContent: 'center',
      alignItems: 'center',
      fontWeight: 'bold',
    }}
  >
    {info}
  </div>
);

const NewProjectView = () => {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        flex: 1, // 0 0 1 for stacked
        justifyContent: 'center',
        alignItems: 'center',
        fontWeight: 'bold',
        /* border: '1px solid rgba(0,0,0,0.125)', */
        padding: 10,
      }}
    >
      <div style={{ fontFamily: 'Arial' }}>
        To add tasks or milestones click on the "+" button in the navigation
        bar.
      </div>
      <div>You can also check out the videos in Get Started.</div>
    </div>
  );
};

const MapTasksOld = ({ tasks, criticalPaths, setCurrentElement }) => {
  return (
    tasks &&
    tasks.map(t => {
      return (
        <Task
          key={t.id}
          task={t}
          isCritical={isCriticalTask(criticalPaths, t.id)}
          setCurrentElement={setCurrentElement}
        />
      );
    })
  );
};

class MapTasks extends React.Component {
  cache = new CellMeasurerCache({
    defaultHeight: 100,
    fixedWidth: true,
  });

  rowRenderer = ({
    key, // Unique key within array of rows
    index, // Index of row within collection
    isScrolling, // The List is currently being scrolled
    isVisible, // This row is visible within the List (eg it is not an overscanned row)
    style, // Style object to be applied to row (to position it)
    parent,
    myTasks,
  }) => {
    const { tasks, criticalPaths, setCurrentElement } = this.props;
    const t = tasks[index];

    return (
      <CellMeasurer
        cache={this.cache}
        columnIndex={0}
        key={key}
        parent={parent}
        rowIndex={index}
      >
        <Task
          key={key}
          task={t}
          isCritical={isCriticalTask(criticalPaths, t.id)}
          setCurrentElement={setCurrentElement}
          style={style}
        />
      </CellMeasurer>
    );
  };

  handleResize = () => {
    this.cache.clearAll();
  };

  render() {
    const { tasks, myTasks } = this.props;
    return (
      <AutoSizer onResize={this.handleResize}>
        {({ height, width }) => (
          <List
            ref={list => (this.list = list)}
            width={width}
            height={height}
            rowCount={tasks.length}
            myTasks={myTasks}
            // rowHeight={120}
            rowHeight={this.cache.rowHeight}
            rowRenderer={this.rowRenderer}
            deferredMeasurementCache={this.cache}
          />
        )}
      </AutoSizer>
    );
  }
}

class MyTasksList extends React.Component {
  render() {
    const {
      tasks,
      currentIndex,
      criticalPaths,
      criticalTaskMap,
      setCurrentElement,
      myTasks,
    } = this.props;
    if (!tasks || !tasks.length) {
      if (currentIndex === 'now') {
        return <NewProjectView />;
      } else if (currentIndex === 'issues') {
        return <EmptyTab info="No problems found." />;
      }
      return <EmptyTab info="No tasks due in this time frame." />;
    } else if (currentIndex === 'issues') {
      const groupedTasks = tasks.reduce((p, c) => {
        if (!p[c.issues]) p[c.issues] = [];
        p[c.issues].push(c);
        return p;
      }, {});

      const horriblyUglyArray = [
        'Tasks that are blocked',
        'Tasks that are running late',
        'Tasks that have no owner but are ready to start',
        'Tasks that have a duration that is too long',
        "Tasks on critical path which are ready to start but haven't yet",
      ];

      return (
        <div className="list-group" style={{ flex: 1, overflowY: 'auto' }}>
          {horriblyUglyArray.map(issueGroup => {
            const issues = groupedTasks[issueGroup];

            if (!issues) return null;

            return (
              <span style={{ marginBottom: 10 }} key={issueGroup}>
                <div
                  className="list-group-item list-group-item-action flex-column align-items-start"
                  style={{ fontWeight: 'bold', background: '#eee' }}
                >
                  {issueGroup}
                </div>
                <MapTasksOld
                  key={currentIndex}
                  ref={mapTasks => (this.mapTasks = mapTasks)}
                  myTasks={myTasks}
                  tasks={issues}
                  criticalPaths={criticalPaths}
                  setCurrentElement={setCurrentElement}
                />
              </span>
            );
          })}
        </div>
      );
    }

    return (
      <div
        className="list-group my-task-list"
        style={{
          flex: 1,
          overflowY: 'auto',
          // border: '1px solid rgba(0,0,0,0.125)',
        }}
      >
        <MapTasks
          key={currentIndex}
          ref={mapTasks => (this.mapTasks = mapTasks)}
          myTasks={myTasks}
          tasks={tasks}
          criticalPaths={criticalPaths}
          setCurrentElement={setCurrentElement}
        />
      </div>
    );
  }
}

const MyTasksList__ = ({
  tasks,
  currentIndex,
  criticalPaths,
  criticalTaskMap,
  setCurrentElement,
  myTasks,
}) => {
  if (!tasks || !tasks.length) {
    if (currentIndex === 'now') {
      return <NewProjectView />;
    } else if (currentIndex === 'issues') {
      return <EmptyTab info="No problems found." />;
    }
    return <EmptyTab info="No tasks due in this time frame." />;
  } else if (currentIndex === 'issues') {
    const groupedTasks = tasks.reduce((p, c) => {
      if (!p[c.issues]) p[c.issues] = [];
      p[c.issues].push(c);
      return p;
    }, {});

    const horriblyUglyArray = [
      'Tasks that are blocked',
      'Tasks that are running late',
      'Tasks that have no owner but are ready to start',
      'Tasks that have a duration that is too long',
      "Tasks on critical path which are ready to start but haven't yet",
    ];

    return (
      <div className="list-group" style={{ flex: 1, overflowY: 'auto' }}>
        {horriblyUglyArray.map(issueGroup => {
          const issues = groupedTasks[issueGroup];

          if (!issues) return null;

          return (
            <span style={{ marginBottom: 10 }} key={issueGroup}>
              <div
                className="list-group-item list-group-item-action flex-column align-items-start"
                style={{ fontWeight: 'bold', background: '#eee' }}
              >
                {issueGroup}
              </div>
              <MapTasks
                ref={mapTasks => (this.mapTasks = mapTasks)}
                myTasks={myTasks}
                tasks={issues}
                criticalPaths={criticalPaths}
                setCurrentElement={setCurrentElement}
              />
            </span>
          );
        })}
      </div>
    );
  }

  return (
    <div
      className="list-group my-task-list"
      style={{
        flex: 1,
        overflowY: 'auto',
        // border: '1px solid rgba(0,0,0,0.125)',
      }}
    >
      <MapTasks
        myTasks={myTasks}
        tasks={tasks}
        criticalPaths={criticalPaths}
        setCurrentElement={setCurrentElement}
      />
    </div>
  );
};

const query = gql`
  query MyTasks($projectId: String, $userId: String) {
    myTasks(projectId: $projectId, userId: $userId) {
      ...CriticalPathTasks
      ...TasksByWeek
    }
  }
  ${CriticalPathTasks}
  ${TasksByWeek}
`;

const MY_TASKS_SUBSCRIPTION = gql`
  subscription myTasks($projectId: String, $userId: String) {
    myTasks(projectId: $projectId, userId: $userId) {
      ...CriticalPathTasks
      ...TasksByWeek
    }
  }
  ${CriticalPathTasks}
  ${TasksByWeek}
`;

const withData = compose(
  graphql(query, {
    options: ({ projectId, userId }) => ({
      variables: {
        projectId,
        userId,
      },
      fetchPolicy: 'cache-and-network',
    }),
    props: props => {
      return {
        subscribeToMyTasks: currentProps => {
          return props.data.subscribeToMore({
            document: MY_TASKS_SUBSCRIPTION,
            variables: {
              userId: currentProps.userId,
              projectId: currentProps.projectId,
            },
            updateQuery: (prev, { subscriptionData }) => {
              return {
                ...prev,
                myTasks: subscriptionData.data.myTasks,
              };
            },
          });
        },
        ...props,
      };
    },
  }),
);

@withData
class MyTasks extends PureComponent {
  state = {
    currentIndex: 'now',
  };

  myTasksList = null;
  subscription = null;

  componentWillMount() {
    const { subscribeToMyTasks, projectId, userId } = this.props;
    this.subscription = subscribeToMyTasks({
      projectId,
      userId,
    });
  }

  componentWillUnmount() {
    this.subscription();
  }

  componentWillReceiveProps(nextProps) {
    const { projectId, userId, subscribeToMyTasks } = this.props;

    if (nextProps.projectId !== projectId || nextProps.userId !== userId) {
      this.subscription();

      this.subscription = subscribeToMyTasks({
        projectId: nextProps.projectId,
        userId: nextProps.userId,
      });
    }
  }

  handleChange = event => {
    this.setState({ value: event.target.value });
  };

  handleChangeTab = currentIndex => {
    // this.myTasksList.mapTasks.cache.clearAll();
    // this.myTasksList.mapTasks.list.scrollToRow(0);
    // setTimeout(() => this.myTasksList.mapTasks.list.scrollToRow(0), 2000);
    // console.log(this.myTasksList.mapTasks.cache);
    // const x = this.myTasksList.mapTasks.list;
    // console.log('list', x);
    // this.myTasksList.mapTasks.list.recomputeRowHeights();
    // const x = this.myTasksList.mapTasks.list;
    // console.log('aaa', x)
    // debugger;
    this.setState({ currentIndex });
  };

  getTasks = () => {
    const {
      data: { myTasks },
    } = this.props;
    const { currentIndex } = this.state;

    const tasksByWeek = myTasks.tasksByWeek.reduce((p, c) => {
      p[c.weekNumber] = c.tasks;
      return p;
    }, {});

    switch (currentIndex) {
      case 0:
        return (tasksByWeek[0] || []).concat(tasksByWeek[1] || []);
      case 1:
        return tasksByWeek[2] || [];
      case 2:
        return (tasksByWeek[3] || [])
          .concat(tasksByWeek[4] || [])
          .concat(tasksByWeek[5] || [])
          .concat(tasksByWeek[6] || []);
      default:
        return tasksByWeek[currentIndex] || [];
    }
  };

  bucketSort = (array, bucketSize, criticalTaskMap) => {
    if (!array || array.length === 0) {
      return array;
    }

    var allBuckets = new Array(bucketSize);

    for (var i = 0; i < allBuckets.length; i++) {
      allBuckets[i] = [];
    }

    array.forEach(function(currentVal) {
      const bucketId = criticalTaskMap[currentVal.id] ? 0 : 1;
      allBuckets[bucketId].push(currentVal);
    });

    const output = [];

    allBuckets.forEach(function(bucket) {
      sortBy(bucket, t => t.calendarDueDays).forEach(function(element) {
        output.push(element);
      });
    });

    return output;
  };

  render() {
    const {
      data: { myTasks, loading },
      projectUsers,
      selectedUser,
      updateSelectedUser,
      setCurrentElement,
    } = this.props;
    const { currentIndex } = this.state;

    if (loading) {
      return <Loading loadingMessage="Loading tasks..." />;
    }

    const tasks = this.getTasks();
    const criticalPaths = myTasks.criticalPathTasks.map(t => t.id);
    const criticalTaskMap = criticalPaths.reduce((p, c) => {
      p[c] = true;
      return p;
    }, {});

    const sortedTasks = this.bucketSort(tasks, 2, criticalTaskMap);

    console.log('myTasks: ', myTasks);

    return (
      <div style={{ flex: 1, flexDirection: 'column', display: 'flex' }}>
        <div style={{}}>
          <span className="panel-label" style={{ lineHeight: '38px' }}>
            Task Look Ahead
          </span>
        </div>
        <Tabs
          currentIndex={currentIndex}
          onChange={this.handleChangeTab}
          setCurrentElement={setCurrentElement}
          projectUsers={projectUsers}
          selectedUser={selectedUser}
          updateSelectedUser={updateSelectedUser}
        />
        <MyTasksList
          ref={myTasksList => (this.myTasksList = myTasksList)}
          currentIndex={currentIndex}
          setCurrentElement={setCurrentElement}
          tasks={sortedTasks}
          myTasks={myTasks}
          criticalPaths={criticalPaths}
          criticalTaskMap={criticalTaskMap}
        />
      </div>
    );
  }
}

export default MyTasks;



// WEBPACK FOOTER //
// ./src/views/Project/TaskHome/MyTasks/index.js